import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UploadService } from '../../../../services/upload.service';
import { ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { ItemsService } from '../../../../services/items.service';

@Component({
  selector: 'app-file-upload-modal',
  templateUrl: './file-upload-modal.component.html',
  styleUrls: ['./file-upload-modal.component.scss']
})
export class FileUploadModalComponent implements OnInit {
  toUpload;
  progress;
  prog
  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
  files: any[] = [];
  //from context
  folder
  scope
  constructor(private uploadService: UploadService,
    private itemsService: ItemsService,
    private dialogRef: ScaffoldDialogRef) { }

  ngOnInit(): void {
  }
  /*
  removeFile(file) {
    this.files.delete(file);
  }
  selectFiles() {
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        this.files.add(files[key]);
      }
    }
  }
  */


  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  upload(index: number) {
    if (index === this.files.length) {
      return;
    }
    const route = [];
    let parent =this.scope; 
    this.folder.route.forEach(fold => {
      route.push(fold.data.title);
      parent = fold.id;
    });
    console.log(this.toUpload);
    let sent = false;
    let file = this.files[index];
    let upload = this.uploadService.uploadSingle(file, this.scope + (route.length > 0 ? "/" + route.join("/") : ""),parent);
    upload.subscribe(p => {
      console.log(p)
      file.progress = p.progress;
      file.error = p.error;
      if (p.progress === 100 && !sent) {
        sent = true;
        let data: any = {
          type: 'files',
          data: {
            title: p.file,
            url: p.url,
            size: p.size,
            type: p.fileref.type
          }
        }
        if (this.folder.id == 'institution') {
          data.data.institution = true;
        }
        if (p.existing?.[0]?.id) {
          let path = "";
          if (this.folder.type) {
            path += "/" + this.folder.type + "/" + this.folder.id;
          }
          path += "/files/" + p.existing[0].id;
          this.updateData(path, data.data);
        } else {
          let path = "";
          if (this.folder.type) {
            path += "/" + this.folder.type + "/" + this.folder.id;
          }
          path += "/files";
          this.createData(path, data);
        }

      }
    });
  }
  /*
  removeStatus(item) {
    if (this.progress && this.progress[item]) {
      var file = this.progress[item].fileref;
      this.files.delete(file);
      delete this.progress[item];
    }
  }

*/
  createData(path, data) {
    this.itemsService.createData(path, data).subscribe(d => {
      //this.navigate(null, this.folder);
    });
  }

  updateData(path, data) {
    this.itemsService.saveViewData(path, { data: data }).subscribe(d => {
     // this.navigate(null, this.folder);
    });
  }
  /**
 * on file drop handler
 */
  onFileDropped($event) {
    $event.preventDefault();
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    if (this.files[index].progress < 100 && !this.files[index].error) {
      console.log("Upload in progress.");
      return;
    }
    this.files.splice(index, 1);
  }


  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
      this.upload(this.files.length - 1);
    }
    this.fileDropEl.nativeElement.value = "";
    
  }

  close() {
    this.dialogRef.close(true);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

}
